const axios = require('axios');
const { errorMapper } = require('../ErrorMapper');

const CURRENT_VERSION = 'v1';

class TravelRestrictionAssociationConnector {
  constructor(configuration) {
    this.httpClient = axios.create(configuration);
  }

  async createTravelRestrictionAssociation(options = {}) {
    try {
      const request = {
        url: `/${CURRENT_VERSION}/travel-restriction-associations`,
        method: 'PUT',
        ...options,
      };

      const { data } = await this.httpClient(request);
      return data;
    } catch (error) {
      return this._handleError(error);
    }
  }

  async removeTravelRestrictionAssociation(id, options = {}) {
    try {
      const request = {
        url: `/${CURRENT_VERSION}/travel-restriction-associations/${id}`,
        method: 'DELETE',
        ...options,
      };

      const { data } = await this.httpClient(request);
      return data;
    } catch (error) {
      return this._handleError(error);
    }
  }

  async getCorporationAssociationById(id) {
    try {
      const request = {
        url: `/${CURRENT_VERSION}/corporation-associations/${id}`,
        method: 'GET',
      };

      const { data } = await this.httpClient(request);
      return data;
    } catch (error) {
      return this._handleError(error);
    }
  }

  async countTravelRestrictionAssociation({ travelRestrictionId }) {
    try {
      const request = {
        url: `/${CURRENT_VERSION}/travel-restriction-associations/count`,
        method: 'GET',
        params: { travelRestrictionId },
      };

      const { data } = await this.httpClient(request);
      return data;
    } catch (error) {
      return this._handleError(error);
    }
  }

  _handleError(error) {
    throw errorMapper(error);
  }
}

module.exports = {
  TravelRestrictionAssociationConnector,
};
